import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57c8e02c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "container flex col" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "flex align-center" }
const _hoisted_5 = { class: "flex align-center justify-between" }
const _hoisted_6 = {
  class: "flex",
  style: {"gap":"12px"}
}
const _hoisted_7 = {
  key: 0,
  class: "flex grow"
}
const _hoisted_8 = { class: "flex panel grow" }
const _hoisted_9 = { class: "flex grow col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold text-muted" }, "Pour quel établissement ?"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "bold" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "flex justify-between grow" }
const _hoisted_17 = {
  class: "panel flex col",
  style: {"width":"350px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted bold" }, "Sections", -1))
const _hoisted_19 = { class: "flex align-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "grow panel" }
const _hoisted_23 = { class: "flex grow align-center justify-center" }
const _hoisted_24 = { class: "bold" }
const _hoisted_25 = { class: "panel flex col" }
const _hoisted_26 = { class: "flex justify-between align-center" }
const _hoisted_27 = { class: "text-muted bold" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "flex g6"
}
const _hoisted_30 = { class: "f12 bold" }
const _hoisted_31 = {
  key: 0,
  class: "text-muted flex col g0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_TrainingTargetStore = _resolveComponent("TrainingTargetStore")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeImage = _resolveComponent("SeImage")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_SeFadeButton = _resolveComponent("SeFadeButton")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeEditableText = _resolveComponent("SeEditableText")!
  const _component_TrainingQuiz = _resolveComponent("TrainingQuiz")!
  const _component_SeTab = _resolveComponent("SeTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SeModal, {
      ref: "categoryModal",
      title: "Categorie"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SeInput, {
          modelValue: _ctx.categoryName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categoryName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_SeButton, { onClick: _ctx.createCategory }, {
          default: _withCtx(() => [
            _createTextVNode("Create category")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_SeModal, {
      ref: "storeFilterModal",
      title: "Filters"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TrainingTargetStore, { ref: "targetStore" }, null, 512),
        _createVNode(_component_SeButton, {
          onPress: _ctx.closeStoreFilterModal,
          class: "modal-valid w100"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        }, 8, ["onPress"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_NavHeader, {
      backButton: "true",
      title: _ctx.state.training!.name
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SeInput, {
            style: {"width":"300px"},
            placeholder: _ctx.Lang.getI18N('name'),
            modelValue: _ctx.state.training!.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.training!.name) = $event))
          }, null, 8, ["placeholder", "modelValue"]),
          _createVNode(_component_SeDropdown, {
            titleFunc: (lang) => lang,
            modelValue: _ctx.state.training.lang,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.training.lang) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SeDropdownItem, { value: "FR" }),
              _createVNode(_component_SeDropdownItem, { value: "EN" })
            ]),
            _: 1
          }, 8, ["titleFunc", "modelValue"]),
          _createVNode(_component_SeDropdown, {
            nullable: true,
            modelValue: _ctx.state.selectedCategory,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.selectedCategory) = $event)),
            titleFunc: (actionType) => actionType.name,
            ref: "typeSelect",
            class: "grow"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.categories, (category) => {
                return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                  displayTitle: false,
                  value: category
                }, {
                  heading: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(category.name), 1)
                    ])
                  ]),
                  tailing: _withCtx(() => [
                    _withDirectives(_createVNode(_component_SeImage, {
                      maxWidth: 18,
                      maxHeight: 18,
                      src: "/ico/edit-blue.svg"
                    }, null, 512), [
                      [_vShow, false]
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 256)),
              _createVNode(_component_SeDropdownItem, {
                displayTitle: false,
                class: "noselect"
              }, {
                heading: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCategoryModal && _ctx.openCategoryModal(...args)), ["stop"])),
                    class: "bold"
                  }, "+ " + _toDisplayString(_ctx.Lang.getI18N("add")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "titleFunc"]),
          _createVNode(_component_ToggleSwitch, {
            modelValue: _ctx.state.training.required,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.training.required) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N('required')), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ToggleSwitch, {
            auto: "true",
            modelValue: _ctx.state.training!.active,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.training!.active) = $event)),
            ref: "switch"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("active")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_SeButton, {
            tooltip: _ctx.Lang.getI18N('save'),
            onPress: _ctx.update,
            ref: "modifyBtn",
            icon: "/ico/save.svg"
          }, null, 8, ["tooltip", "onPress"])
        ])
      ]),
      (_ctx.state.training.type == 'database' || _ctx.state.training.type == 'distributor')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_WideCard, {
                  title: _ctx.state.training?.target.stores.length == 0 &&
              _ctx.state.training?.target.store_tags.length == 0
              ? 'Tout le monde'
              : 'Ciblée'
              ,
                  icon: "/ico/filter.svg"
                }, {
                  subtitle: _withCtx(() => [
                    (
                  _ctx.state.training?.target.stores.length == 0 &&
                  _ctx.state.training?.target.store_tags.length == 0
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Cette formation cible tous les établissements"))
                      : _createCommentVNode("", true),
                    (_ctx.state.training!.target.stores.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createTextVNode("Cette formation cible "),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.state.training?.target.stores.length) + " établissement.", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.state.training!.target.store_tags.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createTextVNode("Cette formation cible "),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.state.training?.target.store_tags.length) + " groupe(s)", 1),
                          _createTextVNode(" d'établissements.")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createVNode(_component_SeFadeButton, {
                      onClick: _ctx.openStoreFilterModal,
                      icon: "/ico/edit-blue.svg"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.training!.sections, (section) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", {
                onClick: () => _ctx.sectionClick(section),
                class: "section-title flex row align-center justify-between"
              }, [
                _createVNode(_component_SeEditableText, {
                  modelValue: section.title,
                  "onUpdate:modelValue": ($event: any) => ((section.title) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_SeFadeButton, {
                    onClick: _ctx.deleteSection,
                    icon: "/ico/trash.svg"
                  }, null, 8, ["onClick"])
                ])
              ], 8, _hoisted_20)
            ]))
          }), 256)),
          _createVNode(_component_SeButton, {
            onPress: _ctx.addSection,
            class: "w100",
            icon: "ico/plus.svg"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ajouter")
            ]),
            _: 1
          }, 8, ["onPress"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.state.selectedSection.title), 1)
          ]),
          _createVNode(_component_SeTab, {
            ref: "tab",
            tabBackgroundColor: "#f3fafa",
            tabs: [_ctx.Lang.getI18N('attachment'), 'Quiz']
          }, {
            "0": _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.Lang.getI18N("attachment")), 1),
                  _hoisted_28
                ]),
                _createVNode(_component_WideCard, {
                  title: _ctx.Lang.getI18N('attachment'),
                  icon: "/ico/file.svg"
                }, {
                  subtitle: _withCtx(() => [
                    (_ctx.state.selectedSection!.attachment != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.state.selectedSection!.attachment.name), 1),
                          _createElementVNode("span", _hoisted_30, " (" + _toDisplayString(_ctx.state.selectedSection!.attachment.type) + ")", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    (_ctx.state.selectedSection!.attachment != null)
                      ? (_openBlock(), _createBlock(_component_SeFadeButton, {
                          key: 0,
                          onClick: _ctx.downloadAttachment,
                          icon: "/ico/download.svg"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("download")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_SeFadeButton, {
                      onClick: [
                        _ctx.uploadAttachment,
                        _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      ],
                      icon: "/ico/upload-blue.svg"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Upload ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["title"]),
                (_ctx.state.selectedSection?.attachment != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                  : _createCommentVNode("", true)
              ])
            ]),
            "1": _withCtx(() => [
              _createVNode(_component_TrainingQuiz)
            ]),
            _: 1
          }, 8, ["tabs"])
        ])
      ])
    ])
  ]))
}